module.exports = __webpack_public_path__ + "assets/yearly-trans-icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/yearly-trans-icon.png
// module id = 1218
// module chunks = 7